import { TMasterdataSyncStatus } from '@monorepo/types';
import produce from 'immer';
import { InputAppMetadataActionTypes, TInputAppMetadataActions } from './metadata.actions';
export type TInputAppMetadata = {
  isOnline: boolean;
  healthCheckPassed: boolean;
  eventsBatchCount: number;
  syncingInfo: {
    [key: string]: TMasterdataSyncStatus;
  };
  isScannerInitialised: boolean;
};
export const BACK_UP_TIME_DIFFERENCE_IN_MILLI_SECONDS = 1 * 60 * 1000;
export const FETCH_SERVER_DEFECTIVES_TIME_DIFFERENCE_IN_MILLI_SECONDS = 5 * 60 * 1000;
export const DAY_END_CHECK_TIME_DIFFERENCE_IN_MILLI_SECONDS = 1 * 60 * 1000;
export const EVENTS_BATCH_COUNT = 10;
export const HEALTH_CHECK_TIME_DIFFERENCE_IN_MILLI_SECONDS = 1 * 15 * 1000;
export const WAITING_TIME_FOR_NEXT_EVENTS_SYNCING_IN_MILLI_SECONDS = 1 * 60 * 1000;
export const TIME_OUT_FOR_SERVER_ERROR = 30 * 60 * 1000;
export const IMAGES_UPLOAD_RETRY_COUNT = 20;
export const IMAGES_UPLOAD_SYNCING_TIME_DIFFERENCE_IN_MILLI_SECONDS = 1 * 60 * 1000;
export const INITIAL_CACHE_RESET_TIMESTAMP = new Date().setHours(0, 0, 0, 0);

export const DELAYED_EVENTS_SLA_IN_DAYS = 3;
export const BCTX_SYNC_TIME_DIFFERENCE_IN_MILLI_SECONDS = 15 * 60 * 1000;
export const EVENTS_SYNC_TIME_DIFFERENCE_IN_MILLI_SECONDS_FOR_APK = 1 * 60 * 1000;
export const INTERVAL_TO_LOG_PENDING_EVENTS_IN_MILLI_SECONDS = 15 * 60 * 1000;
export const INTERVAL_TO_FETCH_LATEST_SESSION_PLANS_IN_MILLI_SECONDS = 5 * 60 * 1000;
export const INTERVAL_TO_UPDATE_WORKING_HOURS_STATUS = 1 * 60 * 1000;
export const INTERVAL_TO_LOG_DEVICE_STATS_IN_MILLI_SECONDS = 5 * 60 * 1000;
export const UNDO_LIMIT = 3;
export const FETCHING_DEFECT_LIST_LOCK_RETRY_TIMEOUT_MS = 30000;
export const MIN_NO_OF_CARTONS_FOR_AUTO_FILL_AND_COMPLETE = 3;
export const MAX_NO_OF_CARTONS_FOR_AUTO_FILL_AND_COMPLETE = 10;

export const metadataInitialState: TInputAppMetadata = {
  isOnline: true,
  healthCheckPassed: true,
  eventsBatchCount: EVENTS_BATCH_COUNT,
  syncingInfo: {},
  isScannerInitialised: false,
};

export function InputAppMetadataStateReducer(
  state: TInputAppMetadata = metadataInitialState,
  action: TInputAppMetadataActions,
): TInputAppMetadata {
  switch (action.type) {
    case InputAppMetadataActionTypes.InitSyncingStatus: {
      const keyToStatus = action.keys.reduce((acc, curr) => {
        acc[curr] = 'INIT';
        return acc;
      }, {} as Record<string, TMasterdataSyncStatus>);
      return produce(state, (draft) => {
        draft.syncingInfo = keyToStatus;
      });
    }
    case InputAppMetadataActionTypes.ClearSyncingStatus: {
      return produce(state, (draft) => {
        draft.syncingInfo = {};
      });
    }
    case InputAppMetadataActionTypes.UpdateSyncingStatus: {
      return produce(state, (draft) => {
        if (draft.syncingInfo[action.key]) {
          draft.syncingInfo[action.key] = action.status;
        }
      });
    }
    case InputAppMetadataActionTypes.UpdateBulkSyncingStatus: {
      return produce(state, (draft) => {
        action.keys.forEach((key) => {
          if (draft.syncingInfo[key]) {
            draft.syncingInfo[key] = action.status;
          }
        });
      });
    }
    case InputAppMetadataActionTypes.UpdateOnlineStatus:
      return produce(state, (draft) => {
        draft.isOnline = action.status;
      });
    case InputAppMetadataActionTypes.UpdateHealthCheckStatus:
      return produce(state, (draft) => {
        draft.healthCheckPassed = action.status;
      });
    case InputAppMetadataActionTypes.InitialiseScanner:
      return produce(state, (draft) => {
        draft.isScannerInitialised = action.isInitialised;
      });
    default:
      return state;
  }
}
